var React = require('react');

function Drop (props) {
    return React.createElement("svg",props,React.createElement("g",{"clipPath":"url(#a)"},React.createElement("path",{"d":"M12 3v17m0-8 3.544-3.544M12 17.3l5.558-5.558M6.8 11a6 6 0 1 0 10.396 0l-5.197-8-5.2 8H6.8z","stroke":"currentColor","strokeWidth":"2","strokeLinecap":"round","strokeLinejoin":"round"})));
}

Drop.defaultProps = {"width":"24","height":"24","fill":"none"};

module.exports = Drop;

Drop.default = Drop;
